"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildPermissionRefined = void 0;
const buildPermissionRefined = (permission) => ({
    ID: permission.ID,
    type: permission.type,
    groupLabel: permission.groupLabel,
    description: permission.description,
    component: permission.component,
    usage: permission.usage,
    lambdas: permission.lambdas,
});
exports.buildPermissionRefined = buildPermissionRefined;
//# sourceMappingURL=PermissionRefined.js.map